import React from "react";
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import CarRegistrationNumber from "./component";
import { fetchData, fetchYearsBasedOnMakeId } from "../lead-year/actions";
import { resetLeadFormData, setData, setRTO, setStep, setOwnerName, setFuelType, setTransmissionType, setVariantActiveScreen, activateLastStep, activateFirstStep, setAllStepFilled, setShowWidget } from "../lead-form/actions";
import { setRegistrationNo, setAnsweredQuestions, setHypothecation } from "../sell-online-offer-price/actions";
import { getVehicleDetail, setUserCarRegistrationNO, setAllDetailFetchedCorrectly, resetRegistrationData, checkForDuplicateAppointment, setDataFaliure, setIsRepeatInspection } from "./actions";
import { setName } from "../../configuration/actions";
import { setExperiment } from "../../shared/ab-experiment/actions";

const mapStateToProps = () => ({
    registrationNo: {
        userCarRegistrationNo
    },
    leadData,
    settings: {
        leadSource
    },
    user: {
        isLoggedIn, secureToken
    }
}) => ({
    userCarRegistrationNo,
    leadData,
    leadSource,
    isLoggedIn,
    secureToken
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setRegistrationNoConnect: setRegistrationNo,
    getVehicleDetailConnect: getVehicleDetail,
    setDataConnect: setData,
    fetchYearListConnect: fetchData,
    fetchYearsBasedOnMakeIdConnect: fetchYearsBasedOnMakeId,
    setStepConnect: setStep,
    setFuelTypeConnect: setFuelType,
    setOwnerNameConnect: setOwnerName,
    setTransmissionTypeConnect: setTransmissionType,
    setVariantActiveScreenConnect: setVariantActiveScreen,
    setRTOConnect: setRTO,
    activateLastStepConnect: activateLastStep,
    activateFirstStepConnect: activateFirstStep,
    setAllStepFilledConnect: setAllStepFilled,
    setUserCarRgistrationNoConnect: setUserCarRegistrationNO,
    resetLeadFormDataConnect: resetLeadFormData,
    setAllDetailFetchedCorrectlyConnect: setAllDetailFetchedCorrectly,
    setAnsweredQuestionsConnect: setAnsweredQuestions,
    setNameConnect: setName,
    resetRegistrationDataConnect: resetRegistrationData,
    setHypothecationConnect: setHypothecation,
    setShowWidgetConnect: setShowWidget,
    checkForDuplicateAppointmentConnect: checkForDuplicateAppointment,
    setDataFaliureConnect: setDataFaliure,
    setExperimentConnect: setExperiment,
    setIsRepeatInspectionConnect: setIsRepeatInspection
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CarRegistrationNumber));

